export default { PACKAGE_VERSION: "1.8.0" };
